import React, { useState,useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import OTPInput, { ResendOTP } from "otp-input-react";
import firebase from '../config/firebase'
import Masteradmin  from '../config/firebase_admin'

import '../css/phoneLogin.css';
import { Button,Input } from 'reactstrap';
import { purple } from "@material-ui/core/colors";
import CircularProgress from '@mui/material/CircularProgress';

export default function PhoneLogin(props) {
  const [OTP, setOTP] = useState("");
  let [number1,setNumber1]=useState(sessionStorage.getItem('otpNumber'))
  let [code,setCode]=useState(false)
  let [error,setErrorMesseg]=useState('')
  console.log(props);
let [edit,setEdit]=useState(false)
  useEffect(() => {
    return () => {
        // Anything in here is fired on component unmount.
        
   // document.body.style.background = null;
  // document.body.style.padding = "";
  // document.body.style.display = "";
  // document.body.style.justifyContent = "";
  // document.body.style.alignItems = "";
  // document.body.style.minHeight = "";
  // document.body.style.fontFamily = "'Jost', sans-serif";
  // document.body.style.alignItems = "";
    }
}, [])
document.body.style.background = "linear-gradient(to bottom, #0f0c29, #302b63, #24243e)";
document.body.style.margin = "0px";
document.body.style.padding = "0px";
document.body.style.display = "flex";
document.body.style.justifyContent = "center";
document.body.style.alignItems = "center";
document.body.style.minHeight = "100vh";
document.body.style.fontFamily = "'Jost', sans-serif";
document.body.style.alignItems = "center";




  useEffect(()=>{
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
  },[])




    const [number,setNumber]=useState(sessionStorage.getItem('otpNumber'))
    let [coderesult,setcoderesult]=useState('')




let onSignInSubmit=()=>{


setErrorMesseg('')

  document.getElementById('recaptcha-container').style.display='block'
  // document.getElementById('MyVerifiedCode').style.display='block'


  const appVerifier = window.recaptchaVerifier;
  firebase.auth().signInWithPhoneNumber(number, appVerifier)
      .then((confirmationResult) => {
        setCode(true)
        // console.log(confirmationResult);
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        window.confirmationResult = confirmationResult;
        document.getElementById('recaptcha-container').style.display='none'
        // document.getElementById('verifiedMe').style.display='block'
        // document.getElementById('SendCode').style.display='none'




        // window.confirmationResult = confirmationResult;


        setcoderesult(confirmationResult)
        // ...
        // console.log("send sucesfully",confirmationResult);
      }).catch((error) => {
        // Error; SMS not sent
        // ...
        setErrorMesseg(error.message)
        document.getElementById('recaptcha-container').style.display='none'

      });

}





let VerifyME=()=>{
    // console.log("verifing in process");
    setErrorMesseg("")
    document.getElementById('animation_show_ha').style.display='flex'
  
  if(OTP=='' )
  {
  setErrorMesseg("Please Fill All Field's")
  document.getElementById('animation_show_ha').style.display='none'
  return
  }
  
  // console.log(code);
    // const code ='1236';
  
    coderesult.confirm(OTP).then((result) => {
    // User signed in successfully.
    const user = result.user;
  
    console.log("SUCESSULY VERIFIED >>>>>>>>>>>>>>.",user.uid);

    
    // var decodedString = ;
    let store=JSON.parse(window.atob(sessionStorage.getItem('#4%f345^*-!23')))  
    


   

    firebase.auth().createUserWithEmailAndPassword(sessionStorage.getItem('email'),JSON.parse(window.atob(sessionStorage.getItem('#4%f345^*-!23'))))
    
    .then((userCredential) => {
console.log('?????????????',userCredential);
var d = new Date();

firebase.firestore().collection("users").doc(userCredential.user.uid).set({
  name: sessionStorage.getItem('name'),
  email: sessionStorage.getItem('email'),
  number: sessionStorage.getItem('otpNumber'),
  approved:'no',
  welcome:'no',
  date:d.getTime(),
  admin_uid:userCredential.user.uid
  
})
.then(()=>{
console.log(">>>>>>>>>>>>>.",'yes');

Masteradmin.auth().createUserWithEmailAndPassword(sessionStorage.getItem('email'),JSON.parse(window.atob(sessionStorage.getItem('#4%f345^*-!23'))))
.then(()=>{
  
  sessionStorage.removeItem('name')
  sessionStorage.removeItem('email')
  sessionStorage.removeItem('#4%f345^*-!23')
  sessionStorage.removeItem('otpNumber')
  
  
  document.getElementById('animation_show_ha').style.display='none'
  props.history.push('/sucess')
})



})
.catch((error)=>{
console.log('dfvfv',error.message);
document.getElementById('animation_show_ha').style.display='none'

})
    
   
    



})
.catch((error) => {
 
  // console.log("e>>>>>>>>>>>>>>>>>>>>>>",error.message);
  document.getElementById('animation_show_ha').style.display='none'

});



})
  .catch((error) => {
 
    setErrorMesseg(error.message)
    document.getElementById('animation_show_ha').style.display='none'

  });
}



  return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column'}}>
   <div id="animation_show_ha" style={{position:'absolute',backgroundColor:'rgb(23, 19, 54,0.8)',width:'100%',display:'none',justifyContent:'center',alignItems:'center',zIndex:'22',height:'100%',marginTop:'0px',}}>
      <CircularProgress size={62} />

      </div>
<div className="formDiv">

<h2 className="head">
  Phone Verification
</h2>



{code?
<>

<p className="pirat" style={{textAlign:'center'}}>
  Your Received OTP on {sessionStorage.getItem('otpNumber')}. Type here 
</p>
<OTPInput 
    value={OTP}
     onChange={setOTP}
      autoFocus 
      OTPLength={6} 
      inputStyles={{borderRadius:3,border:'1px solid purple',backgroundColor:'#fff'}}
    otpType="number"
     disabled={false} 
      />

<Button  className="buttonMe" onClick={()=>VerifyME()} color="danger">Verify</Button>

</>

:
<>
<p className="pirat" style={{textAlign:'center'}}>
  Your Phone number is {sessionStorage.getItem('otpNumber')} Confirm Your number using Confirm button. 
</p>




{edit?
<>
<Input onChange={(e)=>sessionStorage.setItem('otpNumber',e.target.value)} style={{width:200}}  placeholder="Number" />
<Button onClick={()=>{setEdit(!edit)}} className="buttonMe" color="danger">Confirm</Button>

</>
:
<>
<Button  className="buttonMe" onClick={()=>{onSignInSubmit()}}  color="danger">Send code</Button>
<p  onClick={()=>{setEdit(!edit)}} style={{width:'70%',textAlign:'center',color:'red',cursor:'pointer'}}>
Want to change Number ? 
</p>
</>

}

</>}



<p style={{textAlign:'center',width:'80%',color:'red',fontSize:12}}>
  {error}
</p>


</div>


















   



    <div id='recaptcha-container' style={{display:'none',marginTop:10}}>

</div>


    </div>
  );
}


